// NPM
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'actions';
import { isEmpty, remove } from 'lodash';

import { getTag, getTagsForRecommendation } from 'selectors';

import HideTagList from './HideTagList';

import { Button } from 'react-bootstrap';

class RecommendationHideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingTags: [],
    };
  }

  undoHideRecommendation = () => {
    const {
      recommendation,
      updateRecommendationStatus,
      setHidingRecommendation,
    } = this.props;
    const payload = { is_hidden: false };
    updateRecommendationStatus(recommendation.uuid, payload);
    setHidingRecommendation(null);
  };

  completeRecommendationHide = () => {
    const { pendingTags } = this.state;
    const {
      recommendation,
      hideTags,
      setHidingRecommendation,
      removeRecommendationFromList,
    } = this.props;

    if (!isEmpty(pendingTags)) {
      hideTags(pendingTags);
    }

    setHidingRecommendation(null);
    removeRecommendationFromList(recommendation.uuid);
  };

  togglePendingHiddenTag = tag => {
    const { pendingTags } = this.state;

    const tagIsPending = pendingTags.find(pt => {
      return pt.id === tag.id && pt.schema === tag.schema;
    });

    if (tagIsPending) {
      let tags = [...pendingTags];
      remove(tags, pt => pt.id === tag.id && pt.schema === tag.schema);
      this.setState({
        pendingTags: tags,
      });
    } else {
      this.setState({
        pendingTags: [...pendingTags, { id: tag.id, schema: tag.schema }],
      });
    }
  };

  render() {
    const { university, tags, recommendation: { program } } = this.props;
    return (
      <div className="HideRecommendation">
        <div className="HideRecommendation-actions">
          <span className="HideRecommendation-program-info">
            <span className="HideRecommendation-program-name">
              {`${program.name} `}
            </span>
            from
            <span className="HideRecommendation-uni-name">{` ${
              university.name
            } `}</span>
            has been hidden.
          </span>

          <Button
            className="HideRecommendation-actions-undo"
            onClick={this.undoHideRecommendation}
          >
            Undo
          </Button>
          <Button
            className="HideRecommendation-actions-done"
            onClick={this.completeRecommendationHide}
          >
            Done
          </Button>
        </div>

        <span className="HideRecommendation-hide-tags-text mobile-only">
          Tap on tags to hide similar results
        </span>
        <span className="HideRecommendation-hide-tags-text desktop-only">
          Click on categories, subcategories, or locations to hide similar
          results
        </span>
        <HideTagList
          togglePendingHiddenTag={this.togglePendingHiddenTag}
          pendingTags={this.state.pendingTags}
          tags={tags}
        />
      </div>
    );
  }
}

RecommendationHideMenu.propTypes = {
  recommendation: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const university = getTag(state, props.recommendation.program.university);
  return {
    tags: getTagsForRecommendation(state, props),
    university,
    city: getTag(state, university.city),
    province: getTag(state, university.province),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateRecommendationStatus: actions.updateRecommendationStatus,
      getDefaultRecommendations: actions.getDefaultRecommendations,
      hideTags: actions.hideTags,
      setHidingRecommendation: actions.setHidingRecommendation,
      removeRecommendationFromList: actions.removeRecommendationFromList,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  RecommendationHideMenu
);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationHideMenu/index.js